import { render, staticRenderFns } from "./UserViewAccountProducts.vue?vue&type=template&id=2575a044&v-if=userProducts&"
import script from "./UserViewAccountProducts.vue?vue&type=script&lang=js&"
export * from "./UserViewAccountProducts.vue?vue&type=script&lang=js&"
import style0 from "./UserViewAccountProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports